import React, { useState } from 'react';
import classNames from 'classnames';

import { useWindowStore, useAppStore } from '../../stores';

import { ReactComponent as MobileMapControlsVectreLogo } from './MobileMapControlsVectreLogo.svg';
import { ReactComponent as MobileSiteSeeLogo } from './MobileSiteSeeLogo.svg';
import { ReactComponent as DesktopSiteSeeLogo } from './DesktopSiteSeeLogo.svg';

import './VectreInfo.scss';

const VectreInfo = (
  className,
) => {
  const [ toggleVectreInfo, setToggleVectreInfo ] = useState( false );

  const isMobile = useWindowStore((state) => state.isMobile);
  const settings = useAppStore((state) => state.settings);
  const { platform } = settings || {};

  return platform === 'siteSee' && (
    <>
      <div className={classNames( 'vectreInfo',
        { 'vectreInfo--active': toggleVectreInfo },
      )}
      >
        <div className="vectreInfo__content">
          {isMobile ? <MobileSiteSeeLogo className="vectreInfo__siteSeeLogo" /> : <DesktopSiteSeeLogo className="vectreInfo__siteSeeLogo" />}
          <a
            className="vectreInfo__link"
            href="https://www.thevectre.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Find Out More
          </a>
        </div>
      </div>

      <div className={`vectreInfo__toggleWrapper ${className?.className}`}>

        { !isMobile && !toggleVectreInfo && (
          <div className="vectreInfo__toggleAnimation">
            <span/>
            <span/>
            <span/>
            <span/>
          </div>
        )}

        <button
          type="button"
          className={classNames({
            vectreInfo__toggle: true,
            'vectreInfo__toggle--active': toggleVectreInfo,
          } )}
          onClick={() => setToggleVectreInfo( !toggleVectreInfo )}
        >
          <div className="sr-only">The Vectre</div>
          <MobileMapControlsVectreLogo className="vectreInfo__vectreLogo" />
        </button>

      </div>
    </>
  );
};

export default VectreInfo;
